import { render, staticRenderFns } from "./good_list.vue?vue&type=template&id=21329f3e&scoped=true&"
import script from "./good_list.vue?vue&type=script&lang=js&"
export * from "./good_list.vue?vue&type=script&lang=js&"
import style0 from "./good_list.vue?vue&type=style&index=0&id=21329f3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21329f3e",
  null
  
)

export default component.exports